// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"346":"8469390c","549":"20211a16","781":"c651b24f"}[chunkId] + ".chunk.js";
};